export const version = "wordlists/5.6.0";
//# sourceMappingURL=_version.js.map